(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2915],{

/***/ 7689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PackageExtraDetails; }
/* harmony export */ });
/* harmony import */ var _pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8295);
/* harmony import */ var _pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2676);



function PackageExtraDetails(props) {
  var instaUserId = props.instaUserId,
      dispatchTime = props.dispatchTime,
      style = props.style;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
    className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().orderInfoContainer),
    style: style,
    children: [dispatchTime && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().orderInfo),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
        className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().orderInfoHeader),
        children: "Shipping"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().dividerContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
          className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().divider)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
        className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().orderInfoDiscription),
        children: ["Ships within ", dispatchTime, " days"]
      })]
    }), instaUserId && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().orderInfo),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
        className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().orderInfoHeader),
        children: "Support"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().dividerContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
          className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().divider)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
        className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().orderInfoDiscription),
        children: ["DM me on ig", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
          className: (_pages_order_order_module_css__WEBPACK_IMPORTED_MODULE_1___default().linkBorder),
          href: "https://www.instagram.com/" + instaUserId,
          rel: "noreferrer",
          target: "_blank",
          children: instaUserId
        }), " ", "for queries"]
      })]
    })]
  });
}

/***/ }),

/***/ 8311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _toast_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3408);
/* harmony import */ var _toast_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_toast_module_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2676);


function Toast(_ref) {
  var open = _ref.open,
      message = _ref.message,
      type = _ref.type;
  var openClass = open ? "show" : "";

  if (type === "success") {
    return open ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className: "".concat((_toast_module_css__WEBPACK_IMPORTED_MODULE_1___default().toastContainer), " ").concat(openClass),
      style: {
        backgroundColor: "#44c073"
      },
      children: message
    }) : "";
  }

  if (type === "error") {
    return open ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className: "".concat((_toast_module_css__WEBPACK_IMPORTED_MODULE_1___default().toastContainer), " ").concat(openClass),
      style: {
        backgroundColor: "#ff3333"
      },
      children: message
    }) : "";
  }

  return "";
}

/***/ }),

/***/ 112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_FormInput; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6843);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(8943);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(8867);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(8271);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1051);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(5659);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9955);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(5551);
// EXTERNAL MODULE: ./components/utils/form-input.module.css
var form_input_module = __webpack_require__(648);
var form_input_module_default = /*#__PURE__*/__webpack_require__.n(form_input_module);
// EXTERNAL MODULE: ./components/utils/input-loader.module.css
var input_loader_module = __webpack_require__(1252);
var input_loader_module_default = /*#__PURE__*/__webpack_require__.n(input_loader_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loader-spinner@4.0.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-loader-spinner/dist/loader/css/react-spinner-loader.css
var react_spinner_loader = __webpack_require__(4501);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loader-spinner@4.0.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-loader-spinner/dist/index.js
var dist = __webpack_require__(4162);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/utils/InputLoader.js






var InputLoader = function InputLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (input_loader_module_default()).inputLoader,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
      type: "ThreeDots",
      color: "#000000",
      height: 16,
      width: 16,
      timeout: 5000 //3 secs

    })
  });
};

/* harmony default export */ var utils_InputLoader = (InputLoader);
;// CONCATENATED MODULE: ./components/utils/FormInput.js








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




 // Copied from CartStorage for safety




function isLocalStorageAvailable() {
  try {
    if ( false || typeof window.localStorage === "undefined") {
      return false;
    }

    var testKey = "__form_input_storage_test__";
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn("LocalStorage (for FormInput) is not available or accessible: ".concat(e.message));
    return false;
  }
}

var FormInput = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(FormInput, _React$Component);

  var _super = _createSuper(FormInput);

  function FormInput(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, FormInput);

    _this = _super.call(this, props);

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "validate", function (isFocusAble) {
      var _this$state = _this.state,
          inputValue = _this$state.inputValue,
          isLoading = _this$state.isLoading;
      var regex = _this.props.regex;
      if (isLoading) _this.setState({
        isLoading: false
      });
      return new Promise(function (resolve) {
        var _this$validateMethod = _this.validateMethod({
          regex: regex,
          inputValue: inputValue
        }),
            isValid = _this$validateMethod.isValid,
            type = _this$validateMethod.type,
            isInvalid = _this$validateMethod.isInvalid,
            isError = _this$validateMethod.isError;

        if (isValid) {
          if (isError) {
            _this.setState({
              isError: false
            }, function () {
              resolve(true);
            });
          }

          if (isInvalid) {
            _this.setState({
              isInvalid: false
            }, function () {
              resolve(true);
            });
          }
        } else {
          if (type == "validation") {
            _this.setState({
              isInvalid: true,
              isError: isError
            }, function () {
              _this.inputRef.current.focus();

              resolve(false);
            });

            return;
          }

          if (type == "error") {
            _this.setState({
              isError: true,
              isInvalid: isInvalid
            }, function () {
              if (isFocusAble) _this.inputRef.current.focus();
              resolve(false);
            });

            return;
          }
        }

        _this.setState({
          isError: false,
          isInvalid: false
        });

        resolve(true);
      });
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "validateMethod", function (_ref) {
      var regex = _ref.regex,
          inputValue = _ref.inputValue;
      var isOptional = _this.props.isOptional;
      if (!regex && inputValue) return {
        isValid: true,
        isError: false,
        isInvalid: false
      };else if (!inputValue && !isOptional) {
        return {
          isValid: false,
          isError: true,
          isInvalid: false,
          type: "error"
        };
      } else if (!inputValue && isOptional) {
        return {
          isValid: true,
          isError: false,
          isInvalid: false
        };
      } else if (inputValue && regex && regex.test(inputValue)) {
        return {
          isValid: true,
          type: "validation",
          isError: false,
          isInvalid: false
        };
      } else if (inputValue && regex && !regex.test(inputValue)) {
        return {
          isValid: false,
          type: "validation",
          isInvalid: true,
          isError: false
        };
      } else {
        return {
          isValid: false,
          type: "error",
          isError: true,
          isInvalid: true
        };
      }
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "onFocus", function () {
      // this.setState({ isFocus: true, isError: false, isInvalid: false });
      _this.setState({
        isFocus: true
      });
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "onBlur", function () {
      _this.setState({
        isFocus: false
      }, function () {
        var onBlur = _this.props.onBlur;
        var inputValue = _this.state.inputValue; // if (!inputValue) {
        //   this.validate();
        //   return;
        // }

        if (typeof onBlur !== "function") return;
        onBlur(inputValue);
      });
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "onChange", function (e) {
      var _this$props = _this.props,
          saveInLocalStorage = _this$props.saveInLocalStorage,
          name = _this$props.name,
          maxLength = _this$props.maxLength,
          inputType = _this$props.inputType;
      var newValue = e.target.value;

      if (inputType === "number" && maxLength && newValue.length > maxLength) {
        newValue = newValue.slice(0, maxLength);
      }

      _this.setState({
        inputValue: newValue
      });

      if (saveInLocalStorage && name && isLocalStorageAvailable()) {
        // Check availability
        try {
          window.localStorage.setItem(name, newValue);
        } catch (error) {
          console.warn("Error setting item '".concat(name, "' in localStorage in FormInput: ").concat(error.message));
        }
      }

      var onChange = _this.props.onChange;
      if (typeof onChange !== "function") return;
      onChange(newValue);
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "setValue", function (value) {
      _this.setState({
        isLoading: false
      }, function () {
        _this.setState({
          inputValue: value
        });
      });
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "focus", function () {
      _this.inputRef.current.focus();
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "setLoader", function (isLoading) {
      _this.setState({
        isLoading: isLoading
      }, function () {
        setTimeout(function () {
          _this.setState({
            isLoading: false
          });
        }, 5200);
      });
    });

    var _isError = false;
    var isFocus = false;
    var _isInvalid = false;
    var _isLoading = false;
    _this.state = {
      isError: _isError,
      isFocus: isFocus,
      isInvalid: _isInvalid,
      isLoading: _isLoading
    };
    _this.inputRef = /*#__PURE__*/react.createRef();
    return _this;
  }

  (0,createClass/* default */.Z)(FormInput, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          isError = _this$state2.isError,
          inputValue = _this$state2.inputValue,
          isFocus = _this$state2.isFocus,
          isInvalid = _this$state2.isInvalid,
          isLoading = _this$state2.isLoading;
      var _this$props2 = this.props,
          type = _this$props2.type,
          placeholder = _this$props2.placeholder,
          errorMessage = _this$props2.errorMessage,
          maxLength = _this$props2.maxLength,
          inputType = _this$props2.inputType,
          invalidMessage = _this$props2.invalidMessage,
          userInterface = _this$props2.userInterface,
          onKeyDown = _this$props2.onKeyDown,
          textArea = _this$props2.textArea,
          name = _this$props2.name,
          color = _this$props2.color,
          inputBgColor = _this$props2.inputBgColor,
          isInputBgSecondary = _this$props2.isInputBgSecondary,
          readOnly = _this$props2.readOnly,
          disabled = _this$props2.disabled;
      var formInputClass = type === "full" ? (form_input_module_default()).formInput : (form_input_module_default()).halfInput;
      var inputClass = isFocus ? (form_input_module_default()).focusInput : (0,utils.cn)((form_input_module_default()).inputClass, isInputBgSecondary ? "!bg-secondary" : "!bg-".concat(inputBgColor));
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: formInputClass,
        children: [errorMessage ? isError && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (form_input_module_default()).error,
          children: errorMessage
        }) : null, invalidMessage ? isInvalid && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (form_input_module_default()).error,
          children: invalidMessage
        }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: inputClass,
          style: {
            border: isError ? "1px solid red" : ""
          },
          children: [this.props.children, userInterface === "loaded" && isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)(utils_InputLoader, {}), !isLoading && (textArea ? /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
            name: name,
            autoComplete: "on",
            className: (form_input_module_default()).inputStyle,
            placeholder: placeholder,
            value: inputValue || "",
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            maxLength: maxLength,
            disabled: disabled || false,
            readOnly: readOnly,
            onChange: this.onChange,
            ref: this.inputRef,
            onKeyDown: onKeyDown,
            style: {
              "--input-color": color
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            name: name,
            autoComplete: "on",
            className: (form_input_module_default()).inputStyle,
            placeholder: placeholder,
            value: inputValue || "",
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            maxLength: maxLength,
            disabled: disabled || false,
            readOnly: readOnly,
            type: inputType,
            onChange: this.onChange,
            ref: this.inputRef,
            onKeyDown: onKeyDown,
            style: {
              "--input-color": color
            }
          }))]
        })]
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var isError = nextProps.isError;

      if (isError) {
        console.log({
          nextProps: nextProps
        });
        this.setState({
          isInvalid: true,
          isError: true
        }, function () {
          _this2.inputRef.current.focus();
        });
      } else {
        this.setState({
          isInvalid: false,
          isError: false
        }, function () {});
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          name = _this$props3.name;
      var localValue = null; // Default to null

      if (name && isLocalStorageAvailable()) {
        // Check availability
        try {
          localValue = window.localStorage.getItem(name);
        } catch (error) {
          console.warn("Error getting item '".concat(name, "' from localStorage in FormInput: ").concat(error.message));
          localValue = null; // Ensure null on error
        }
      } // Use component prop value > localStorage value > empty string


      this.setState({
        inputValue: value || localValue || ""
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }]);

  return FormInput;
}(react.Component);

/* harmony default export */ var utils_FormInput = (FormInput);

/***/ }),

/***/ 1548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1503);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7623);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2676);





var NotFound = function NotFound() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: "/404.png",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().title404),
      alt: "404 image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundMessage),
      children: ["The page you are looking for does not exist. ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}), " Sorry :("]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
      href: "/",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundHeadHome),
      children: "Head home"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);
/*
  import Link from "next/link";

const NotFound = () => (
  <div className="flex min-h-screen items-center justify-center bg-[var(--side-bg-color)]">
    <div className="flex h-screen w-screen max-w-[var(--max-width)] flex-col items-center justify-center bg-[var(--app-bg-color)]">
      <img
        src="/illustrations/404-Error-illustration.svg"
        alt="404 image"
        height="250px"
        width="250px"
        className="object-cover"
      />

      <p className="mt-8 max-w-sm text-center text-xl">
        Oops! We couldn't find that page. <br />
        Let's get you back on track.
      </p>

      <Link href="/" prefetch={true}>
        <a className="mt-8 rounded-lg bg-primary px-6 py-4 text-xl">Head home</a>
      </Link>

      <footer className="fixed bottom-10 left-1/2 -translate-x-1/2 transform text-center">
        <small className="opacity-70">
          Illustrations by{" "}
          <a href="https://storyset.com/web" target="_blank" rel="noopener noreferrer">
            Storyset
          </a>
        </small>
      </footer>
    </div>
  </div>
);

export default NotFound;

*/

/***/ }),

/***/ 9216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9955);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(2186);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7039);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/head.js
var head = __webpack_require__(2057);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(6971);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./components/AppContainer.jsx
var AppContainer = __webpack_require__(1503);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6843);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(8943);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(8867);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(8271);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1051);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(5659);
// EXTERNAL MODULE: ./components/Buttons/image-button.module.css
var image_button_module = __webpack_require__(1786);
var image_button_module_default = /*#__PURE__*/__webpack_require__.n(image_button_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Buttons/ImageButton.js




var ImageButton = function ImageButton(_ref) {
  var children = _ref.children,
      type = _ref.type,
      action = _ref.action;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    className: (image_button_module_default())[type],
    onClick: action,
    style: {
      minHeight: "20px",
      minWidth: "20px",
      display: "block"
    },
    children: children
  });
};

/* harmony default export */ var Buttons_ImageButton = (ImageButton);
;// CONCATENATED MODULE: ./components/Buttons/ShareSvg.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ShareSvg = function ShareSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "var(--font-background)",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "none",
      stroke: "var(--font-background)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M15.43 7.702c-7.88.296-11.99 7.53-13.26 11.694a.471.471 0 0 0 .461.604c.194 0 .37-.117.452-.293 2.959-6.286 9.624-7.392 12.431-7.143.244.022.42.232.42.477v2.084a.5.5 0 0 0 .848.358l3.916-3.805a.5.5 0 0 0 .064-.641L16.846 5.33a.5.5 0 0 0-.913.283v1.58a.518.518 0 0 1-.502.509Z"
    })
  }));
};

/* harmony default export */ var Buttons_ShareSvg = (ShareSvg);
;// CONCATENATED MODULE: ./components/Buttons/ProductShareButton.js










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var ProductShareButton = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(ProductShareButton, _React$Component);

  var _super = _createSuper(ProductShareButton);

  function ProductShareButton(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, ProductShareButton);

    _this = _super.call(this, props);

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "share", /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var tempInput;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (true) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (!(window.navigator.share && !window.frameElement)) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return window.navigator.share({
                title: _this.props.name,
                url: window.location.href
              });

            case 6:
              _this.setState({
                isShared: true
              });

              _context.next = 24;
              break;

            case 9:
              if (!window.navigator.clipboard) {
                _context.next = 16;
                break;
              }

              _context.next = 12;
              return window.navigator.clipboard.writeText(window.location.href);

            case 12:
              _this.setState({
                isShared: true
              });

              if (_this.props.toast) {
                _this.props.toast();
              }

              _context.next = 24;
              break;

            case 16:
              // Create a fallback by creating a temporary input element
              tempInput = document.createElement("input");
              tempInput.value = window.location.href;
              document.body.appendChild(tempInput);
              tempInput.select();
              document.execCommand("copy");
              document.body.removeChild(tempInput);

              _this.setState({
                isShared: true
              });

              if (_this.props.toast) {
                _this.props.toast();
              }

            case 24:
              _context.next = 30;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](0);
              // Handle share cancellation or errors gracefully
              console.log("Share failed:", _context.t0); // Don't show error if user just cancelled the share

              if (_context.t0.name !== "AbortError") {
                alert("Could not share at this time. Please try again.");
              }

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 26]]);
    })));

    var isShared = false;
    _this.state = {
      isShared: isShared
    };
    return _this;
  }

  (0,createClass/* default */.Z)(ProductShareButton, [{
    key: "render",
    value: function render() {
      var isShared = this.state.isShared; // console.log(" ShareButton STATE", isShared);

      var imageButtonType = isShared ? "disabled" : "raised";
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_ImageButton, {
        type: imageButtonType,
        action: this.share,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_ShareSvg, {})
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }]);

  return ProductShareButton;
}(react.Component);

/* harmony default export */ var Buttons_ProductShareButton = (ProductShareButton);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/image.js
var next_image = __webpack_require__(1968);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-responsive-carousel@3.2.23/node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(6050);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-responsive-carousel@3.2.23/node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(770);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(8071);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1008);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(473);
// EXTERNAL MODULE: ./components/Carousel/indicator.module.css
var indicator_module = __webpack_require__(4258);
var indicator_module_default = /*#__PURE__*/__webpack_require__.n(indicator_module);
;// CONCATENATED MODULE: ./components/Carousel/Indicator.js




var Indicator = function Indicator(_ref) {
  var handler = _ref.handler,
      isSelected = _ref.isSelected;
  if (isSelected) return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: (indicator_module_default()).selectedIndicator
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    className: (indicator_module_default()).normalIndicator,
    onClick: handler
  });
};

/* harmony default export */ var Carousel_Indicator = (Indicator);
// EXTERNAL MODULE: ./components/Carousel/next-arrow.module.css
var next_arrow_module = __webpack_require__(1354);
var next_arrow_module_default = /*#__PURE__*/__webpack_require__.n(next_arrow_module);
;// CONCATENATED MODULE: ./components/Carousel/NextArrowSvg.jsx


function NextArrowSvg_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function NextArrowSvg_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NextArrowSvg_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NextArrowSvg_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var NextArrowSvg = function NextArrowSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", NextArrowSvg_objectSpread(NextArrowSvg_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "var(--color-primary)",
      fillRule: "nonzero",
      d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm3.707 16.707-4.5 4.5a.997.997 0 0 1-.707.293c-.883 0-1.339-1.075-.707-1.707L17.586 16l-3.793-3.793a1 1 0 0 1 1.414-1.414l4.5 4.5a1 1 0 0 1 0 1.414z"
    })
  }));
};

/* harmony default export */ var Carousel_NextArrowSvg = (NextArrowSvg);
;// CONCATENATED MODULE: ./components/Carousel/NextArrow.js





var NextArrow = function NextArrow(_ref) {
  var handler = _ref.handler;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (next_arrow_module_default()).buttonContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: handler,
      className: (next_arrow_module_default()).nextButton,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_NextArrowSvg, {})
    })
  });
};

/* harmony default export */ var Carousel_NextArrow = (NextArrow);
// EXTERNAL MODULE: ./components/Carousel/prev-arrow.module.css
var prev_arrow_module = __webpack_require__(5837);
var prev_arrow_module_default = /*#__PURE__*/__webpack_require__.n(prev_arrow_module);
;// CONCATENATED MODULE: ./components/Carousel/PrevArrowSvg.jsx


function PrevArrowSvg_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PrevArrowSvg_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PrevArrowSvg_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PrevArrowSvg_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var PrevArrowSvg = function PrevArrowSvg(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", PrevArrowSvg_objectSpread(PrevArrowSvg_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "var(--color-primary)",
      fillRule: "nonzero",
      d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm-3.707 16.707 4.5 4.5a.997.997 0 0 0 .707.293c.883 0 1.339-1.075.707-1.707L14.414 16l3.793-3.793a1 1 0 0 0-1.414-1.414l-4.5 4.5a1 1 0 0 0 0 1.414z"
    })
  }));
};

/* harmony default export */ var Carousel_PrevArrowSvg = (PrevArrowSvg);
;// CONCATENATED MODULE: ./components/Carousel/PrevArrow.js





var PrevArrow = function PrevArrow(_ref) {
  var handler = _ref.handler;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (prev_arrow_module_default()).buttonContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      onClick: handler,
      className: (prev_arrow_module_default()).prevButton,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_PrevArrowSvg, {})
    })
  });
};

/* harmony default export */ var Carousel_PrevArrow = (PrevArrow);
;// CONCATENATED MODULE: ./components/Carousel/index.js



 // requires a loader










var DM2BuyCarousel = function DM2BuyCarousel(_ref) {
  var _product$productPhoto;

  var store = _ref.store,
      product = _ref.product;

  var _useState = (0,react.useState)(0),
      selectedItem = _useState[0],
      setSelectedItem = _useState[1]; // Reset to first image when product changes


  (0,react.useEffect)(function () {
    setSelectedItem(0);
  }, [product === null || product === void 0 ? void 0 : product.id]);
  var photos = product === null || product === void 0 ? void 0 : product.productPhotos; // react-responsive-carousel computes the slide list's transform ONCE, in its constructor, from
  // the children it has at mount. Mounted before the product fetch resolves it sees zero slides,
  // treats index 0 as "past the last slide" (infiniteLoop), parks the list at translate3d(0) and
  // waits for a transition end that never comes; when the photos arrive it binds events but never
  // recomputes the position, so the wrap-around clone of the LAST photo is what the page lands on
  // while the first dot is lit. Not mounting it until there are photos, and keying it by product
  // so a client-side navigation between products gets a fresh constructor, fixes both.

  if (!(photos !== null && photos !== void 0 && photos.length)) return null;
  return (
    /*#__PURE__*/
    // `pdp-carousel` scopes the vertical-centring rules in globals.css to this carousel: the
    // home hero reuses .carousel with a height of its own.
    (0,jsx_runtime.jsx)("div", {
      style: {
        padding: "0px 18px"
      },
      className: "pdp-carousel z-10 mt-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(js/* Carousel */.lr, {
        selectedItem: selectedItem,
        onChange: setSelectedItem,
        showThumbs: false,
        showStatus: false,
        infiniteLoop: true,
        showIndicators: (product === null || product === void 0 ? void 0 : (_product$productPhoto = product.productPhotos) === null || _product$productPhoto === void 0 ? void 0 : _product$productPhoto.length) > 1 ? true : false // centerMode={true}
        // centerSlidePercentage={110}
        ,
        renderArrowPrev: function renderArrowPrev(onClickHandler) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_PrevArrow, {
            handler: onClickHandler
          });
        },
        renderArrowNext: function renderArrowNext(onClickHandler) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_NextArrow, {
            handler: onClickHandler
          });
        },
        renderIndicator: function renderIndicator(onClickHandler, isSelected, index) {
          var _product$allPhotos;

          if (((_product$allPhotos = product.allPhotos) === null || _product$allPhotos === void 0 ? void 0 : _product$allPhotos.length) < 2) return null;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_Indicator, {
            handler: onClickHandler,
            isSelected: isSelected
          }, index);
        },
        preventMovementUntilSwipeScrollTolerance: true,
        swipeScrollTolerance: 50,
        children: product.productPhotos && product.productPhotos.map(function (photo, index) {
          // Extract the image name from the original URL
          var imageName = photo.split("/").pop();
          var newPhoto = photo.includes("dm2buy") ? "https://dm2buy-drop-resized-gga4c6azekgcgngp.z02.azurefd.net/dm2buy/".concat(imageName) : (0,cdn/* toCdnUrl */.V$)(photo);
          var fallBackPhoto = photo;
          var resolved = (0,media/* resolveImage */.rs)(photo, product.productPhotosV2, "pdp");

          if (resolved.isV2) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
              resolved: resolved,
              alt: product.name || "",
              width: 360,
              height: 425 // Slides are laid out off-viewport by react-responsive-carousel, so a lazy
              // slide is blank on the first swipe. Legacy rendered every slide with
              // `priority`; keep the first two eager as the compromise.
              ,
              loading: index < 2 ? "eager" : "lazy",
              fetchpriority: index === 0 ? "high" : undefined,
              imgClassName: "mx-auto h-auto max-w-full"
            }, index);
          }

          return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            unoptimized: "true",
            src: newPhoto,
            height: 425,
            onLoad: function onLoad() {},
            onError: function onError(e) {
              // Only fallback if we're not already using the fallback
              if (e.target.src !== fallBackPhoto) {
                e.target.src = fallBackPhoto;
              } // If we're already on fallback and it failed, do nothing

            },
            width: 360,
            priority: true
          }, index);
        })
      }, product === null || product === void 0 ? void 0 : product.id)
    })
  );
};

/* harmony default export */ var Carousel = (DM2BuyCarousel);
// EXTERNAL MODULE: ./components/Cart/Basket.jsx + 1 modules
var Basket = __webpack_require__(7027);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7033);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(5551);
// EXTERNAL MODULE: ./services/helper.js + 23 modules
var helper = __webpack_require__(3236);
// EXTERNAL MODULE: ./components/file-picker.module.css
var file_picker_module = __webpack_require__(4930);
var file_picker_module_default = /*#__PURE__*/__webpack_require__.n(file_picker_module);
;// CONCATENATED MODULE: ./components/FilePicker.jsx









function FilePicker(_ref) {
  var showContainer = _ref.showContainer,
      attachmentUrl = _ref.attachmentUrl,
      setAttachmentUrl = _ref.setAttachmentUrl,
      attachmentLoading = _ref.attachmentLoading,
      setIsAttachmentLoading = _ref.setIsAttachmentLoading;

  var _useState = (0,react.useState)([]),
      files = _useState[0],
      setFiles = _useState[1];

  var fileInputRef = (0,react.useRef)(null);

  var triggerFileInput = function triggerFileInput() {
    fileInputRef.current.click();
  };

  var handleFileChange = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event) {
      var fileInputs, totalFiles, uploadPromises, uploadedUrls, newFiles;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fileInputs = Array.from(event.target.files);

              if (!(fileInputs.length > 0 && !attachmentLoading)) {
                _context.next = 23;
                break;
              }

              _context.prev = 2;
              setIsAttachmentLoading(true); // Check if adding these files would exceed the limit

              totalFiles = files.length + fileInputs.length;

              if (!(totalFiles > 5)) {
                _context.next = 8;
                break;
              }

              alert("Maximum 5 files allowed");
              return _context.abrupt("return");

            case 8:
              // Upload all files
              uploadPromises = fileInputs.map(function (file) {
                return (0,helper/* uploadFileToAzure */.LB)(file, "dm2buy");
              });
              _context.next = 11;
              return Promise.all(uploadPromises);

            case 11:
              uploadedUrls = _context.sent;
              // Update state
              newFiles = fileInputs.map(function (file, index) {
                return {
                  file: file,
                  url: uploadedUrls[index]
                };
              });
              setFiles(function (prev) {
                return [].concat((0,toConsumableArray/* default */.Z)(prev), (0,toConsumableArray/* default */.Z)(newFiles));
              });
              setAttachmentUrl(function (prev) {
                return [].concat((0,toConsumableArray/* default */.Z)(prev || []), (0,toConsumableArray/* default */.Z)(uploadedUrls));
              });
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](2);
              console.error("Error uploading files:", _context.t0);

            case 20:
              _context.prev = 20;
              setIsAttachmentLoading(false);
              return _context.finish(20);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 17, 20, 23]]);
    }));

    return function handleFileChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // const handleRemoveFile = () => {
  //   setFile(null);
  //   setAttachmentUrl(null);
  //   fileInputRef.current.value = "";
  // };


  var handleRemoveFile = function handleRemoveFile(indexToRemove) {
    setFiles(function (prev) {
      return prev.filter(function (_, index) {
        return index !== indexToRemove;
      });
    });
    setAttachmentUrl(function (prev) {
      return prev.filter(function (_, index) {
        return index !== indexToRemove;
      });
    });
  };

  if (!showContainer) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [files.length < 5 && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      className: (0,utils.cn)((file_picker_module_default()).customButton, "!border-fontBackground !text-fontBackground"),
      onClick: triggerFileInput,
      disabled: attachmentLoading,
      children: attachmentLoading ? "Uploading..." : "Select files"
    }), files.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (file_picker_module_default()).fileDisplay,
      children: files.map(function (fileObj, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-2 flex items-center justify-between rounded border bg-white p-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: (file_picker_module_default()).fileName,
            children: fileObj.file.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (file_picker_module_default()).removeButton,
            onClick: function onClick() {
              return handleRemoveFile(index);
            },
            children: "\xD7"
          })]
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "file",
      ref: fileInputRef,
      accept: "image/*",
      multiple: true,
      onChange: handleFileChange,
      className: (file_picker_module_default()).hiddenInput
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: (file_picker_module_default()).maxFileWarning,
      children: "This product supports customisations. Upload reference photos (max 5 files, 5MB each)"
    })]
  });
}
// EXTERNAL MODULE: ./components/Footer/Footer.jsx + 2 modules
var Footer = __webpack_require__(6268);
// EXTERNAL MODULE: ./components/Loader.jsx
var Loader = __webpack_require__(4834);
// EXTERNAL MODULE: ./components/Navbar/index.jsx + 1 modules
var Navbar = __webpack_require__(7817);
// EXTERNAL MODULE: ./components/OrderDetails/PackageExtraDetails.js
var PackageExtraDetails = __webpack_require__(7689);
// EXTERNAL MODULE: ./components/product-custom-fields.module.css
var product_custom_fields_module = __webpack_require__(2316);
var product_custom_fields_module_default = /*#__PURE__*/__webpack_require__.n(product_custom_fields_module);
// EXTERNAL MODULE: ./components/utils/FormInput.js + 1 modules
var FormInput = __webpack_require__(112);
;// CONCATENATED MODULE: ./components/ProductCustomFields.js




function ProductCustomFields(_ref) {
  var product = _ref.product,
      _ref$selectedCustomAt = _ref.selectedCustomAttributes,
      selectedCustomAttributes = _ref$selectedCustomAt === void 0 ? [] : _ref$selectedCustomAt,
      theme = _ref.theme;
  var customAttributes = product.customAttributes;
  (0,react.useEffect)(function () {
    if (selectedCustomAttributes.length) {
      customAttributes === null || customAttributes === void 0 ? void 0 : customAttributes.map(function (attribute, index) {
        var _selectedCustomAttrib;

        attribute.ref.current.state.inputValue = ((_selectedCustomAttrib = selectedCustomAttributes[index]) === null || _selectedCustomAttrib === void 0 ? void 0 : _selectedCustomAttrib.value) || "";
      });
    }
  }, [selectedCustomAttributes]);
  var isThemePresent = !!(theme !== null && theme !== void 0 && theme.backgroundColor) && !!(theme !== null && theme !== void 0 && theme.primaryColor);

  if (!customAttributes || customAttributes.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (product_custom_fields_module_default()).customFieldsGrid,
    children: customAttributes.map(function (attribute, index) {
      var _attribute$fields, _selectedCustomAttrib2, _selectedCustomAttrib3;

      return (attribute === null || attribute === void 0 ? void 0 : (_attribute$fields = attribute.fields) === null || _attribute$fields === void 0 ? void 0 : _attribute$fields.Required) === "YES" ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
        initialValue: ((_selectedCustomAttrib2 = selectedCustomAttributes[index]) === null || _selectedCustomAttrib2 === void 0 ? void 0 : _selectedCustomAttrib2.value) || "",
        ref: attribute === null || attribute === void 0 ? void 0 : attribute.ref,
        saveInLocalStorage: true,
        inputType: "text",
        type: "half",
        placeholder: attribute === null || attribute === void 0 ? void 0 : attribute.name,
        regex: /^(?!\s*$).+/,
        inputBgColor: isThemePresent ? undefined : "bg-appGray",
        isInputBgSecondary: isThemePresent
      }, attribute === null || attribute === void 0 ? void 0 : attribute.name) : /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput/* default */.Z, {
        initialValue: ((_selectedCustomAttrib3 = selectedCustomAttributes[index]) === null || _selectedCustomAttrib3 === void 0 ? void 0 : _selectedCustomAttrib3.value) || "",
        ref: attribute === null || attribute === void 0 ? void 0 : attribute.ref,
        saveInLocalStorage: true,
        inputType: "text",
        type: "half",
        placeholder: attribute === null || attribute === void 0 ? void 0 : attribute.name // errorMessage={`${attribute?.fields?.Name} can't be blank`}
        ,
        isInputBgSecondary: isThemePresent,
        inputBgColor: isThemePresent ? undefined : "bg-appGray"
      }, attribute === null || attribute === void 0 ? void 0 : attribute.name);
    })
  });
}
// EXTERNAL MODULE: ./components/product-size-fields.module.css
var product_size_fields_module = __webpack_require__(6040);
var product_size_fields_module_default = /*#__PURE__*/__webpack_require__.n(product_size_fields_module);
;// CONCATENATED MODULE: ./components/ProductSizeFields.js





var ProductSizeFields = function ProductSizeFields(_ref) {
  var selectedSize = _ref.selectedSize,
      sizeVariants = _ref.sizeVariants,
      updateSelectedSize = _ref.updateSelectedSize,
      theme = _ref.theme;
  var selected = selectedSize;

  if (!selected) {
    selected = sizeVariants[0]["name"];
  }

  var isThemePresent = !!(theme !== null && theme !== void 0 && theme.backgroundColor) && !!(theme !== null && theme !== void 0 && theme.primaryColor);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (product_size_fields_module_default()).productSizeContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (product_size_fields_module_default()).sizesContainer,
      children: sizeVariants.map(function (sizeVariant, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (0,utils.cn)((product_size_fields_module_default()).sizeContainer + " " + (selected === (sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.name) ? (product_size_fields_module_default()).selected : ""), selected === (sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.name) ? "cursor-pointer border-primary bg-primary text-fontPrimary" : isThemePresent ? "cursor-pointer border-secondary bg-secondary text-fontBackground" : "cursor-pointer border-appGray bg-appGray text-fontBackground"),
          style: index === 0 ? {
            marginLeft: 0
          } : index === sizeVariants.length - 1 ? {
            marginRight: 0
          } : {},
          onClick: function onClick() {
            return updateSelectedSize(sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.name);
          },
          children: sizeVariant === null || sizeVariant === void 0 ? void 0 : sizeVariant.name
        }, index + 1);
      })
    })
  });
};

/* harmony default export */ var components_ProductSizeFields = (ProductSizeFields);
// EXTERNAL MODULE: ./components/SideNavDrawer.jsx + 2 modules
var SideNavDrawer = __webpack_require__(2130);
// EXTERNAL MODULE: ./contexts/StoreDataContext.js + 1 modules
var StoreDataContext = __webpack_require__(3104);
// EXTERNAL MODULE: ./components/StoreItem.jsx + 1 modules
var StoreItem = __webpack_require__(1041);
;// CONCATENATED MODULE: ./components/SimilarProducts.jsx









var SimilarProducts = function SimilarProducts(_ref) {
  var _context$storeData;

  var collectionId = _ref.collectionId,
      currentProductId = _ref.currentProductId;
  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var storeId = context === null || context === void 0 ? void 0 : (_context$storeData = context.storeData) === null || _context$storeData === void 0 ? void 0 : _context$storeData.id;

  var _useState = (0,react.useState)([]),
      products = _useState[0],
      setProducts = _useState[1];

  var _useState2 = (0,react.useState)(true),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  (0,react.useEffect)(function () {
    var fetchSimilarProducts = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var url, response, data, filteredProducts;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsLoading(true);
                _context.prev = 1;
                url = "".concat((0,helper/* getPublicServerEndpoint */.rq)(), "/v3/product/store/").concat(storeId, "/collectionv2?page=1&limit=10&source=web&collectionId=").concat(collectionId);
                _context.next = 5;
                return fetch(url);

              case 5:
                response = _context.sent;
                _context.next = 8;
                return response.json();

              case 8:
                data = _context.sent;
                // filter out the current product from the list
                filteredProducts = data.data.docs.filter(function (product) {
                  return product.id !== currentProductId;
                });
                setProducts(filteredProducts);
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                console.log("🚀 ~ fetchSimilarProducts ~ err:", _context.t0);
                setProducts([]);

              case 17:
                _context.prev = 17;
                setIsLoading(false);
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13, 17, 20]]);
      }));

      return function fetchSimilarProducts() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchSimilarProducts();
  }, [collectionId, storeId, currentProductId]);
  if (isLoading) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: "Loading Similar Products..."
  });
  if (products.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-6 px-6",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: "text-lg font-semibold",
      children: "Similar Products"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hide-scrollbar mt-6 flex flex-row overflow-x-auto overflow-y-hidden",
      children: products.map(function (product, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-shrink-0",
          style: {
            width: "140px",
            marginRight: index !== products.length - 1 ? "16px" : "0px"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StoreItem/* default */.Z // cohort={cohort}
          , {
            usedForCollectionhome: true,
            product: product,
            pageSize: products.length,
            customHeightWidth: "h-[180px] w-[140px]"
          })
        }, product.id);
      })
    })]
  });
};

/* harmony default export */ var components_SimilarProducts = (SimilarProducts);
// EXTERNAL MODULE: ./components/Toast.js
var Toast = __webpack_require__(8311);
// EXTERNAL MODULE: ./services/frontend/CartStorage.js + 2 modules
var CartStorage = __webpack_require__(9150);
// EXTERNAL MODULE: ./services/frontend/client-apis.js
var client_apis = __webpack_require__(8248);
// EXTERNAL MODULE: ./utils/analytics.js
var analytics = __webpack_require__(7991);
// EXTERNAL MODULE: ./utils/analyticsConfig.js
var analyticsConfig = __webpack_require__(7981);
// EXTERNAL MODULE: ./pages/404.js
var _404 = __webpack_require__(1548);
// EXTERNAL MODULE: ./pages/product/product.module.css
var product_module = __webpack_require__(1568);
var product_module_default = /*#__PURE__*/__webpack_require__.n(product_module);
;// CONCATENATED MODULE: ./pages/product/[slug].js



function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _slug_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _slug_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _slug_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _slug_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
































var ProductPage = function ProductPage() {
  var _storeData$storePrefs, _product$store5, _product$store5$homeP, _productData$collecti, _productData$collecti2, _productData$collecti3, _productData$collecti4, _productData$productP, _cart$products, _cart$products2, _productData$store, _productData$store2, _productData$store3, _productData$store3$s, _productData$store4, _productData$store5, _productData$store5$c, _findProductStockAndP2;

  var router = (0,next_router.useRouter)();
  var slug = router.query.slug; // context data

  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var storeData = context === null || context === void 0 ? void 0 : context.storeData;
  var themeData = context === null || context === void 0 ? void 0 : context.themeData;
  var isProplanActive = context === null || context === void 0 ? void 0 : context.isProplanActive;
  var lowStockThreshold = storeData === null || storeData === void 0 ? void 0 : (_storeData$storePrefs = storeData.storePrefs) === null || _storeData$storePrefs === void 0 ? void 0 : _storeData$storePrefs.lowStockThreshold; // Product states

  var productId = slug;

  var _useState = (0,react.useState)(null),
      product = _useState[0],
      setProduct = _useState[1];

  var _useState2 = (0,react.useState)(""),
      productUrl = _useState2[0],
      setProductUrl = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      productLoading = _useState3[0],
      setProductLoading = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      productError = _useState4[0],
      setProductError = _useState4[1]; // other states


  var _useState5 = (0,react.useState)(false),
      showCart = _useState5[0],
      setShowCart = _useState5[1];

  var _useState6 = (0,react.useState)(null),
      cart = _useState6[0],
      _setCart = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      sideNavOpen = _useState7[0],
      setSideNavOpen = _useState7[1];

  var _useState8 = (0,react.useState)(null),
      selectedSize = _useState8[0],
      setSelectedSize = _useState8[1];

  var _useState9 = (0,react.useState)([]),
      selectedCustomAttributes = _useState9[0],
      setSelectedCustomAttributes = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      focusActive = _useState10[0],
      setFocusActive = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      open = _useState11[0],
      setOpen = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      attachmentLoading = _useState12[0],
      setAttachmentLoading = _useState12[1];

  var _useState13 = (0,react.useState)([]),
      attachmentUrl = _useState13[0],
      _setAttachmentUrl = _useState13[1];

  var _useState14 = (0,react.useState)(null),
      productData = _useState14[0],
      setProductData = _useState14[1];

  var _useState15 = (0,react.useState)(null),
      showLowStockAlert = _useState15[0],
      setShowLowStockAlert = _useState15[1];

  var _useState16 = (0,react.useState)(false),
      isExpanded = _useState16[0],
      setIsExpanded = _useState16[1];

  var _useState17 = (0,react.useState)(false),
      hasOverflow = _useState17[0],
      setHasOverflow = _useState17[1];

  var descriptionRef = (0,react.useRef)(null);
  var customFieldsRef = (0,react.useRef)(null); // Fetch product data

  (0,react.useEffect)(function () {
    var fetchProduct = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var productResponse;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (productId) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                setProductLoading(true);
                _context.next = 6;
                return (0,client_apis/* getProductClientSide */.k1)(productId, storeData === null || storeData === void 0 ? void 0 : storeData.subdomain);

              case 6:
                productResponse = _context.sent;

                if (productResponse.errorCode) {
                  setProductError(productResponse.errorCode);
                } else {
                  setProduct(productResponse.product);
                  setProductUrl(productResponse.productUrl);
                }

                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                console.error("Product fetch error:", _context.t0);
                setProductError(404);

              case 14:
                _context.prev = 14;
                setProductLoading(false);
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10, 14, 17]]);
      }));

      return function fetchProduct() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchProduct();
  }, [productId, storeData === null || storeData === void 0 ? void 0 : storeData.subdomain]); // product_viewed is the top of the storefront funnel. Keyed on product.id so
  // it fires once per product, not on every re-render of the same page.

  (0,react.useEffect)(function () {
    var _product$variantOptio;

    if (!(product !== null && product !== void 0 && product.id)) return;
    (0,analytics.trackEvent)(analyticsConfig.EVENTS.PRODUCT_VIEWED, {
      product_id: product.id,
      product_name: product.name,
      product_price: product.price,
      product_quantity_available: product.quantity,
      product_has_variants: Boolean((_product$variantOptio = product.variantOptions) === null || _product$variantOptio === void 0 ? void 0 : _product$variantOptio.length),
      product_is_low_stock: (0,helper/* checkProductOrActiveVariantHasLowStock */.PE)(product, lowStockThreshold)
    });
  }, [product === null || product === void 0 ? void 0 : product.id]);
  (0,react.useEffect)(function () {
    var pdSizeVariantOptions = [];

    if (product) {
      var _pdSizeVariantOptions, _product$store, _product$store2;

      pdSizeVariantOptions = product.variantOptions && product.variantOptions.length === 1 ? product.variantOptions : product.variantOptions && product.variantOptions.length > 1 ? product.variantOptions.filter(function (vop) {
        return vop.type === "fit" && vop.availableStock > 0;
      }) : [];
      var customAttributes = product.customAttributes && product.customAttributes.length ? product.customAttributes.map(function (attribute) {
        var attrib = _slug_objectSpread({}, attribute);

        attrib.ref = /*#__PURE__*/react.createRef();
        return attrib;
      }) : [];
      setSelectedSize(pdSizeVariantOptions && pdSizeVariantOptions.length ? (_pdSizeVariantOptions = pdSizeVariantOptions[0]) === null || _pdSizeVariantOptions === void 0 ? void 0 : _pdSizeVariantOptions.name : "");
      setProductData(_slug_objectSpread(_slug_objectSpread({}, product), {}, {
        allPhotos: product === null || product === void 0 ? void 0 : product["productPhotos"],
        headerPhoto: product === null || product === void 0 ? void 0 : product["productPhotos"][0],
        headerDescription: product === null || product === void 0 ? void 0 : product.headerDescription,
        shippingFee: (product === null || product === void 0 ? void 0 : (_product$store = product.store) === null || _product$store === void 0 ? void 0 : _product$store["shippingFee"]) || 0,
        shippingFeeCap: product === null || product === void 0 ? void 0 : (_product$store2 = product.store) === null || _product$store2 === void 0 ? void 0 : _product$store2["shippingFeeCap"],
        quantity: 1,
        // set default product quantity to 1
        customAttributes: customAttributes
      }));
    }
  }, [product]);
  (0,react.useEffect)(function () {
    if (productData || selectedSize) {
      setShowLowStockAlert((0,helper/* checkProductOrActiveVariantHasLowStock */.PE)({
        product: productData,
        variantName: selectedSize,
        lowStockThreshold: lowStockThreshold
      }));
    }
  }, [productData, selectedSize, lowStockThreshold]); // compare with prevProductId

  (0,react.useEffect)(function () {
    initializeProduct();
  }, [productId]);
  (0,react.useEffect)(function () {
    if (true) {
      window.setTimeout(function () {
        if (descriptionRef.current) {
          var element = descriptionRef.current;
          var overflow = element.scrollHeight > element.clientHeight;
          setHasOverflow(overflow); // Only show button if there's overflow

          if (!overflow) {
            setIsExpanded(true); // Auto-expand if no overflow
          }
        }
      }, 100);
    }
  }, [productData === null || productData === void 0 ? void 0 : productData.description, selectedSize]); // Reset overflow state when product changes

  (0,react.useEffect)(function () {
    setIsExpanded(false); // setHasOverflow(false);
  }, [productData === null || productData === void 0 ? void 0 : productData.id]); // Only run this useEffect when selectedSize actually changes

  (0,react.useEffect)(function () {
    // Only run if selectedSize has a value (not on initial load)
    if (selectedSize) {
      // Reset expanded state when size changes
      setIsExpanded(false); // Wait for DOM to update, then check overflow

      var timerId = window.setTimeout(function () {
        if (descriptionRef.current) {
          var element = descriptionRef.current;
          var overflow = element.scrollHeight > element.clientHeight;
          setHasOverflow(overflow);
        }
      }, 0);
      return function () {
        return window.clearTimeout(timerId);
      };
    }
  }, [selectedSize]);

  var initializeProduct = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var cartData, productArr, _sizeVariantOptions$, _productSizeVariantOp, selectedCustomAttributesVal, sizeVariantOptions, productSizeVariantOptions, selectedSizeVal, inputs;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return CartStorage/* default.initializeCart */.Z.initializeCart();

            case 2:
              cartData = _context2.sent;

              _setCart(cartData);

              productArr = cartData.products.filter(function (productV) {
                return productV.id === productId;
              });

              if (productArr.length > 0) {
                selectedCustomAttributesVal = productArr[0].customAttributes;
                sizeVariantOptions = productArr[0].variantOptions && productArr[0].variantOptions.length ? productArr[0].variantOptions.filter(function (vop) {
                  return vop.type === "fit";
                }) : [];
                productSizeVariantOptions = [];

                if (product) {
                  productSizeVariantOptions = product.variantOptions && product.variantOptions.length ? product.variantOptions.filter(function (vop) {
                    return vop.type === "fit";
                  }) : [];
                }

                selectedSizeVal = sizeVariantOptions && sizeVariantOptions.length ? (_sizeVariantOptions$ = sizeVariantOptions[0]) === null || _sizeVariantOptions$ === void 0 ? void 0 : _sizeVariantOptions$.name : productSizeVariantOptions && productSizeVariantOptions.length ? (_productSizeVariantOp = productSizeVariantOptions[0]) === null || _productSizeVariantOp === void 0 ? void 0 : _productSizeVariantOp.name : "";
                setSelectedSize(selectedSizeVal);
                setSelectedCustomAttributes(selectedCustomAttributesVal);
              }

              if (true) {
                window.document.body.style.scrollBehavior = "smooth";
                inputs = window.document.querySelectorAll("input");
                inputs.forEach(function (input) {
                  input.onfocus = function () {
                    setFocusActive(true);
                  };

                  input.onblur = function () {
                    setTimeout(function () {
                      setFocusActive(false);
                    }, 2000);
                  };
                });
              }

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function initializeProduct() {
      return _ref2.apply(this, arguments);
    };
  }();

  var updateAddedToCart = function updateAddedToCart() {};

  var findProductStockAndPrice = function findProductStockAndPrice(size) {
    var _product$variantOptio2;

    // Only treat empty size as "sold out" if the product actually has variants
    if (!size && product.variantOptions && product.variantOptions.length > 0 && ((_product$variantOptio2 = product.variantOptions[0]) === null || _product$variantOptio2 === void 0 ? void 0 : _product$variantOptio2.availableStock) === 0) {
      size = "-";
      return {
        stockAvailable: 0
      };
    }

    if (!size) {
      size = "-";
    }

    var variantPrice = product.variantOptions;
    var variantObj = {};

    if (!variantPrice || variantPrice && !variantPrice.length) {
      if (Object.prototype.hasOwnProperty.call(product, "availableStock") && !Object.prototype.hasOwnProperty.call(product, "stockAvailable")) {
        product.stockAvailable = product.availableStock;
      }

      return product;
    }

    variantPrice.forEach(function (variant) {
      var vSize = (variant === null || variant === void 0 ? void 0 : variant.type) === "fit" ? variant === null || variant === void 0 ? void 0 : variant.name : "-";

      if (!variantObj[vSize]) {
        variantObj[vSize] = {
          price: variant === null || variant === void 0 ? void 0 : variant.price,
          stockAvailable: variant === null || variant === void 0 ? void 0 : variant.availableStock
        };
      }
    });

    if (variantObj && variantObj[size]) {
      return variantObj[size];
    } else {
      return null;
    }
  };

  var sizeVariants = (0,react.useMemo)(function () {
    return product && product.variantOptions && product.variantOptions.length ? product.variantOptions.filter(function (vop) {
      return vop.type === "fit";
    }) : [];
  }, [product]);

  var validated = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var isValid, isFocusAble, _iterator, _step, ca, _ca$ref, _ca$ref$current;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isValid = true;
              isFocusAble = true;
              _iterator = _createForOfIteratorHelper(productData.customAttributes);
              _context3.prev = 3;

              _iterator.s();

            case 5:
              if ((_step = _iterator.n()).done) {
                _context3.next = 14;
                break;
              }

              ca = _step.value;

              if (!((ca === null || ca === void 0 ? void 0 : ca.required) === true || !ca)) {
                _context3.next = 12;
                break;
              }

              _context3.next = 10;
              return (_ca$ref = ca.ref) === null || _ca$ref === void 0 ? void 0 : (_ca$ref$current = _ca$ref.current) === null || _ca$ref$current === void 0 ? void 0 : _ca$ref$current.validate(isFocusAble);

            case 10:
              if (_context3.sent) {
                _context3.next = 12;
                break;
              }

              isValid = false;

            case 12:
              _context3.next = 5;
              break;

            case 14:
              _context3.next = 19;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](3);

              _iterator.e(_context3.t0);

            case 19:
              _context3.prev = 19;

              _iterator.f();

              return _context3.finish(19);

            case 22:
              return _context3.abrupt("return", isValid);

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 16, 19, 22]]);
    }));

    return function validated() {
      return _ref3.apply(this, arguments);
    };
  }();

  var storeProductToCart = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var _product$store3, _product$store4, _product$store4$shipp;

      var customAttributes, _iterator2, _step2, ca, _product, cartVal, updatedCart, productIndex;

      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              customAttributes = [];
              _iterator2 = _createForOfIteratorHelper(productData.customAttributes);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  ca = _step2.value;

                  if (ca.ref.current.state.inputValue.trim() !== "") {
                    customAttributes.push({
                      name: ca === null || ca === void 0 ? void 0 : ca.name,
                      value: ca.ref.current.state.inputValue
                    });
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }

              if (selectedSize) {
                productData.size = selectedSize;
              }

              _product = _slug_objectSpread({}, productData);
              _product.customAttributes = customAttributes; // For web: use attachmentLinkV2 (array)

              _product.attachmentLinkV2 = attachmentUrl; // For mobile compatibility: use attachmentLink (string - first file only)

              _product.attachmentLink = attachmentUrl.length > 0 ? attachmentUrl[0] : "";
              cartVal = CartStorage/* default.getCart */.Z.getCart();
              updatedCart = JSON.parse(JSON.stringify(cartVal));
              productIndex = updatedCart.products.findIndex(function (item) {
                return item.id === productData.id && item.size === productData.size;
              });

              if (productIndex !== -1) {
                _product.quantity = updatedCart.products[productIndex].quantity || 1;
                updatedCart.products[productIndex] = _product;
              } else {
                if (!_product.quantity) {
                  _product.quantity = 1;
                }

                updatedCart.products.push(_product);
              }

              updatedCart.shippingFee = (_product === null || _product === void 0 ? void 0 : (_product$store3 = _product.store) === null || _product$store3 === void 0 ? void 0 : _product$store3.shippingCharge) || (_product === null || _product === void 0 ? void 0 : (_product$store4 = _product.store) === null || _product$store4 === void 0 ? void 0 : (_product$store4$shipp = _product$store4.shippingInfo) === null || _product$store4$shipp === void 0 ? void 0 : _product$store4$shipp.shippingCharge) || 0;
              updatedCart.shippingFeeCap = _product.shippingFeeCap;
              _context4.next = 16;
              return CartStorage/* default.saveCart */.Z.saveCart(updatedCart);

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function storeProductToCart() {
      return _ref4.apply(this, arguments);
    };
  }();

  var showToast = function showToast() {
    try {
      setOpen(true);
      setTimeout(function () {
        setOpen(false);
      }, 3000);
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Share operation was cancelled");
      }
    }
  };

  var addToCart = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if ( true && window.dataLayer) {
                window.dataLayer.push({
                  event: "add_to_cart",
                  category: "Button",
                  action: "Click",
                  label: "Add To Cart",
                  product: productData.name
                });
              }

              _context6.next = 3;
              return validated(productData);

            case 3:
              if (!_context6.sent) {
                _context6.next = 6;
                break;
              }

              if (true) {
                if (focusActive) {
                  window.scrollTo(0, 0);
                  window.document.body.scrollTop = 0;
                }
              }

              setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
                var _currentCart$products, _currentCart$products2;

                var currentCart;
                return regenerator_default().wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return storeProductToCart(productData);

                      case 2:
                        currentCart = CartStorage/* default.getCart */.Z.getCart();

                        _setCart(currentCart);

                        (0,analytics.trackEvent)(analyticsConfig.EVENTS.PRODUCT_ADDED_TO_CART, {
                          product_id: productData === null || productData === void 0 ? void 0 : productData.id,
                          product_name: productData === null || productData === void 0 ? void 0 : productData.name,
                          product_price: productData === null || productData === void 0 ? void 0 : productData.price,
                          product_size: productData === null || productData === void 0 ? void 0 : productData.size,
                          cart_item_count: (_currentCart$products = currentCart === null || currentCart === void 0 ? void 0 : (_currentCart$products2 = currentCart.products) === null || _currentCart$products2 === void 0 ? void 0 : _currentCart$products2.length) !== null && _currentCart$products !== void 0 ? _currentCart$products : 0
                        });

                        if (currentCart.products && currentCart.products.length > 0) {
                          setTimeout(function () {
                            setShowCart(true);
                          }, 100);
                        } else {
                          setShowCart(true);
                        }

                        updateAddedToCart(product.id, true);

                      case 7:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              })), 400);

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function addToCart() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleReadLess = function handleReadLess() {
    setIsExpanded(false);

    if (descriptionRef.current) {
      var element = descriptionRef.current;
      var elementTop = element.offsetTop; // const elementBottom = elementTop + element.offsetHeight;

      var viewportTop = window.pageYOffset; // const viewportBottom = viewportTop + window.innerHeight;
      // Check if element is off-screen (above viewport)

      var isOffScreen = elementTop < viewportTop; // Only scroll if element is off-screen

      if (isOffScreen) {
        var elementPosition = elementTop - 80; // 80px offset from top

        window.scrollTo({
          top: elementPosition,
          behavior: "smooth"
        });
      }
    }
  };

  var alreadyAddedToCart = (0,react.useMemo)(function () {
    if (cart && cart.products && cart.products.length > 0) {
      var productArr = cart.products.filter(function (productV) {
        return productV.id === productId && productV.size === selectedSize;
      });

      if (productArr.length > 0) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  }, [cart, productId, selectedSize]);
  (0,react.useEffect)(function () {
    var _findProductStockAndP;

    var productPrice = sizeVariants.length ? (_findProductStockAndP = findProductStockAndPrice(selectedSize, product)) === null || _findProductStockAndP === void 0 ? void 0 : _findProductStockAndP.price : product === null || product === void 0 ? void 0 : product.price;
    setProductData(function (prev) {
      return _slug_objectSpread(_slug_objectSpread({}, prev), {}, {
        price: productPrice
      });
    });
  }, [selectedSize]);
  var homePageEnabled = product === null || product === void 0 ? void 0 : (_product$store5 = product.store) === null || _product$store5 === void 0 ? void 0 : (_product$store5$homeP = _product$store5.homePage) === null || _product$store5$homeP === void 0 ? void 0 : _product$store5$homeP.homePageEnabled;
  var showSimilarProducts = Array.isArray(productData === null || productData === void 0 ? void 0 : productData.collectionV2) && (productData === null || productData === void 0 ? void 0 : (_productData$collecti = productData.collectionV2) === null || _productData$collecti === void 0 ? void 0 : _productData$collecti.length) > 0 && (productData === null || productData === void 0 ? void 0 : (_productData$collecti2 = productData.collectionV2[0]) === null || _productData$collecti2 === void 0 ? void 0 : _productData$collecti2._id) && (productData === null || productData === void 0 ? void 0 : productData.id);
  var activeCollectionId = productData === null || productData === void 0 ? void 0 : (_productData$collecti3 = productData.collectionV2) === null || _productData$collecti3 === void 0 ? void 0 : (_productData$collecti4 = _productData$collecti3.find(function (col) {
    return col.isActive;
  })) === null || _productData$collecti4 === void 0 ? void 0 : _productData$collecti4._id;

  if (productLoading || !storeData) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {});
  }

  if (productError === 404 || !product) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_404["default"], {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(AppContainer/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "m-0 flex w-full max-w-[var(--max-width)] flex-col justify-around bg-background pt-[70px] text-fontBackground",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
          children: "dm2buy"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "description",
          content: productData.headerDescription
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "title",
          content: productData === null || productData === void 0 ? void 0 : productData.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "icon",
          href: "https://dm2buy.blob.core.windows.net/dm2buy/favicon.ico"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          href: "https://fonts.googleapis.com/css2?family=Roboto:wght@700&family=Roboto:wght@400;700&display=swap",
          rel: "stylesheet"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "viewport",
          content: "width=device-width, initial-scale=1, maximum-scale=1,user-scalable=0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:type",
          content: "website"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:title",
          content: productData === null || productData === void 0 ? void 0 : productData.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:description",
          content: productData === null || productData === void 0 ? void 0 : productData.headerDescription
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:image",
          content: (0,media/* ogImage */.Qf)(productData === null || productData === void 0 ? void 0 : (_productData$productP = productData.productPhotos) === null || _productData$productP === void 0 ? void 0 : _productData$productP[0], productData === null || productData === void 0 ? void 0 : productData.productPhotosV2)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:site_name",
          content: "dm2buy"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:url",
          content: productUrl
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:card",
          content: "summary"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:url",
          content: productUrl
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: "twitter:title",
          content: productData === null || productData === void 0 ? void 0 : productData.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "twitter:description",
          content: productData === null || productData === void 0 ? void 0 : productData.headerDescription
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "twitter:image",
          content: productData === null || productData === void 0 ? void 0 : productData.headerPhoto
        })]
      }), cart !== null && cart !== void 0 && (_cart$products = cart.products) !== null && _cart$products !== void 0 && _cart$products.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(Basket/* default */.Z, {
        fromProductPage: true,
        isBasketOpen: showCart,
        setCart: function setCart(value) {
          return _setCart(value);
        },
        cartData: cart,
        updateAddedToCart: updateAddedToCart,
        setHideInAdvance: function setHideInAdvance() {},
        handleShowCart: function handleShowCart() {
          return setShowCart(!showCart);
        },
        store: storeData,
        isProplanActive: isProplanActive
      }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* default */.Z, {
        cartActive: cart !== null && cart !== void 0 && (_cart$products2 = cart.products) !== null && _cart$products2 !== void 0 && _cart$products2.length ? true : false,
        handleShowCart: function handleShowCart() {
          return setShowCart(!showCart);
        },
        homeActive: homePageEnabled && homePageEnabled === true ? true : false,
        store: productData === null || productData === void 0 ? void 0 : productData.store,
        storeName: (productData === null || productData === void 0 ? void 0 : (_productData$store = productData.store) === null || _productData$store === void 0 ? void 0 : _productData$store.storeName) || "",
        toggleSideNav: function toggleSideNav() {
          return setSideNavOpen(!sideNavOpen);
        },
        theme: themeData
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideNavDrawer/* default */.Z, {
        isOpen: sideNavOpen,
        toggleDrawer: function toggleDrawer() {
          return setSideNavOpen(!sideNavOpen);
        },
        store: storeData
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel, {
        store: storeData,
        product: productData
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (product_module_default()).productSub,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (product_module_default()).productHead,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: (0,utils.cn)((product_module_default()).productHeading, "!text-fontBackground"),
            children: productData.name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_ProductShareButton, {
            name: productData.name,
            toast: showToast
          })]
        }), showLowStockAlert && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-sm text-red-500",
          children: "Only few left!"
        }), productData && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (product_module_default()).priceContainer
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PackageExtraDetails/* default */.Z, {
          dispatchTime: (productData === null || productData === void 0 ? void 0 : (_productData$store2 = productData.store) === null || _productData$store2 === void 0 ? void 0 : _productData$store2["dispatchTime"]) || (productData === null || productData === void 0 ? void 0 : (_productData$store3 = productData.store) === null || _productData$store3 === void 0 ? void 0 : (_productData$store3$s = _productData$store3.shippingInfo) === null || _productData$store3$s === void 0 ? void 0 : _productData$store3$s["dispatchTime"]),
          instaUserId: (productData === null || productData === void 0 ? void 0 : (_productData$store4 = productData.store) === null || _productData$store4 === void 0 ? void 0 : _productData$store4.instagramHandle) || (productData === null || productData === void 0 ? void 0 : (_productData$store5 = productData.store) === null || _productData$store5 === void 0 ? void 0 : (_productData$store5$c = _productData$store5.contactInfo) === null || _productData$store5$c === void 0 ? void 0 : _productData$store5$c.instagramHandle),
          style: {
            margin: "20px 0"
          }
        }), sizeVariants && sizeVariants.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_ProductSizeFields, {
          theme: themeData,
          sizeVariants: sizeVariants,
          selectedSize: selectedSize,
          updateSelectedSize: function updateSelectedSize(size) {
            return setSelectedSize(size);
          }
        }) : "", (productData === null || productData === void 0 ? void 0 : productData.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (product_module_default()).descriptionContainer,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: descriptionRef,
              className: (0,utils.cn)((product_module_default()).description, "break-words", !isExpanded ? "line-clamp-5" : "min-h-16"),
              dangerouslySetInnerHTML: {
                __html: (0,helper/* sanitizeHtml */.Z6)(productData.description)
              }
            }), hasOverflow && (isExpanded ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "mt-2 cursor-pointer font-bold text-primary underline hover:text-primary",
              onClick: handleReadLess,
              children: "Read less"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "cursor-pointer bg-background font-bold text-primary underline hover:text-primary",
              onClick: function onClick() {
                return setIsExpanded(true);
              },
              children: "Read more"
            }))]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCustomFields, {
          theme: themeData,
          selectedCustomAttributes: selectedCustomAttributes,
          product: productData,
          ref: customFieldsRef
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilePicker, {
          showContainer: productData === null || productData === void 0 ? void 0 : productData.isAttachmentEnabled,
          attachmentUrl: attachmentUrl,
          setAttachmentUrl: function setAttachmentUrl(url) {
            return _setAttachmentUrl(url);
          },
          attachmentLoading: attachmentLoading,
          setIsAttachmentLoading: function setIsAttachmentLoading(loading) {
            return setAttachmentLoading(loading);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (product_module_default()).callToAction,
          children: ((_findProductStockAndP2 = findProductStockAndPrice(selectedSize, productData)) === null || _findProductStockAndP2 === void 0 ? void 0 : _findProductStockAndP2.stockAvailable) <= 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: (product_module_default()).soldOutButton,
            children: "Sold Out"
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            id: "add-to-bag-btn",
            className: "mt-2 flex w-full justify-between rounded-2xl bg-primary px-6 py-4 text-fontPrimary",
            onClick: addToCart,
            disabled: attachmentLoading,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: alreadyAddedToCart ? "Added to Bag" : "Add to Bag"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: "".concat(String.fromCharCode(0x20b9)).concat(productData.price)
            })]
          })
        })]
      }), showSimilarProducts && isProplanActive && /*#__PURE__*/(0,jsx_runtime.jsx)(components_SimilarProducts, {
        collectionId: activeCollectionId,
        currentProductId: productData.id
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
        theme: themeData
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Toast/* default */.Z, {
        type: "success",
        message: "Link copied successfully",
        open: open
      })]
    })
  });
};

/* harmony default export */ var _slug_ = (ProductPage);

/***/ }),

/***/ 4192:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[slug]",
      function () {
        return __webpack_require__(9216);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"flat":"image-button_flat__dZ1sl","raised":"image-button_raised__pl4uM","disabled":"image-button_disabled__HgfQ9"};

/***/ }),

/***/ 4258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectedIndicator":"indicator_selectedIndicator__qnhBJ","normalIndicator":"indicator_normalIndicator__FpBXv"};

/***/ }),

/***/ 1354:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nextButton":"next-arrow_nextButton__FJr_R","buttonContainer":"next-arrow_buttonContainer__sppDe"};

/***/ }),

/***/ 5837:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"prevButton":"prev-arrow_prevButton__wnL5q","buttonContainer":"prev-arrow_buttonContainer__Yo479"};

/***/ }),

/***/ 4930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"file-picker_title__mO5v6","hiddenInput":"file-picker_hiddenInput__R1sZW","customButton":"file-picker_customButton__oE2kg","fileDisplay":"file-picker_fileDisplay__aOXAy","fileName":"file-picker_fileName__rkag2","removeButton":"file-picker_removeButton__jUQ_G","maxFileWarning":"file-picker_maxFileWarning__UUKSP"};

/***/ }),

/***/ 2316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customFieldsGrid":"product-custom-fields_customFieldsGrid__otSPV"};

/***/ }),

/***/ 6040:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productSizeContainer":"product-size-fields_productSizeContainer__4On6T","sizesContainer":"product-size-fields_sizesContainer__fAVz8","sizeContainer":"product-size-fields_sizeContainer__FtE_u","selected":"product-size-fields_selected__igF5x","sizeHeading":"product-size-fields_sizeHeading__Dxrle"};

/***/ }),

/***/ 3408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toastContainer":"toast_toastContainer__DcoDw"};

/***/ }),

/***/ 648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formInput":"form-input_formInput__tg95g","halfInput":"form-input_halfInput__vrAW1","inputClass":"form-input_inputClass__H5LA_","focusInput":"form-input_focusInput__HBbT_","error":"form-input_error__x7Owd","inputStyle":"form-input_inputStyle__TzgGt"};

/***/ }),

/***/ 1252:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8295:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"order_container__pblK5","containerChild":"order_containerChild__fc3VK","paymentSuccessContainer":"order_paymentSuccessContainer__r5fjh","orderSuccess":"order_orderSuccess__fErFD","thankyouText":"order_thankyouText__XJJjY","floated":"order_floated__nzI8B","successDiv":"order_successDiv__delgZ","successMessage":"order_successMessage__SQOuW","influencerImage":"order_influencerImage__oTStl","feedbackMessage":"order_feedbackMessage__2q1uQ","paraOne":"order_paraOne__dtO97","headingOne":"order_headingOne__FLSud","failedMessageContainer":"order_failedMessageContainer__AzcsS","errorHeader":"order_errorHeader__viTyg","errorText":"order_errorText__SPR3i","retryButton":"order_retryButton__iEG_q","packageDetailContainer":"order_packageDetailContainer__5aIY2","packageDetailDiv":"order_packageDetailDiv__ZQXYH","packageDetail":"order_packageDetail__SLa0_","packageIcon":"order_packageIcon__sLz_a","orderDiv":"order_orderDiv__POs5W","orderName":"order_orderName__4cxv4","orderTotal":"order_orderTotal__fdDzN","orderInfoContainer":"order_orderInfoContainer__qFEwp","orderInfo":"order_orderInfo__cZvbW","divider":"order_divider__7EQ3A","orderInfoHeader":"order_orderInfoHeader__2fCOj","orderInfoSecond":"order_orderInfoSecond__bD_lv","orderInfoDiscription":"order_orderInfoDiscription__QZe7w","dividerContainer":"order_dividerContainer__6EfWp","buyerContainer":"order_buyerContainer__d_sd_","buyerInfo":"order_buyerInfo__llTP9","buyerName":"order_buyerName__ekf33","buyerAddress":"order_buyerAddress__Ys9gr","homeIcon":"order_homeIcon__wwXT7","linkBorder":"order_linkBorder__cZPpE"};

/***/ }),

/***/ 1568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"product_container__mdjCC","product":"product_product__1YZcB","productSub":"product_productSub__JqYyr","productHead":"product_productHead__YEuqy","productHeading":"product_productHeading__pAUFh","price":"product_price__f1jjM","priceContainer":"product_priceContainer__TjUe2","callToAction":"product_callToAction__d86XI","buyNowButton":"product_buyNowButton__0_s__","shipping":"product_shipping__FKdtY","day":"product_day__A_GEa","soldOutButton":"product_soldOutButton__xpO2_","description":"product_description__j2HLb"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9248,885,3129,5695,760,2455,7234,6166,4162,9117,2868,4469,3352,9150,5713,6765,9774,2888,179], function() { return __webpack_exec__(4192); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);